document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.wp-block-hcp-carousel--slides')
      .forEach(function (carouselEl) {
        var flkty =
          Flickity.data(carouselEl) ||
          new Flickity(
            carouselEl,
            JSON.parse(carouselEl.getAttribute('data-flickity'))
          );

        var total = flkty.cells.length;

        flkty.cells.forEach(function (cell, idx) {
          const slide = cell.element;
          slide.setAttribute('role', 'group');
          slide.setAttribute(
            'aria-label',
            'Slide ' + (idx + 1) + ' of ' + total
          );

          slide.querySelectorAll('a').forEach((link) => {
            link.setAttribute('tabindex', '-1');
          });
        });

        function updateAccessibility(selectedIndex) {
          const slidesToShow = 5; 

          flkty.cells.forEach(function (cell, idx) {
            const slide = cell.element;
            const links = slide.querySelectorAll('a');

            const isVisible =
              idx >= selectedIndex && idx < selectedIndex + slidesToShow;

            if (isVisible) {
              slide.removeAttribute('aria-hidden');

              links.forEach((link, i) => {
                link.removeAttribute('tabindex');
                if (i === 0) link.setAttribute('aria-current', 'true');
              });
            } else {
              slide.setAttribute('aria-hidden', 'true');

              links.forEach((link) => {
                link.setAttribute('tabindex', '-1');
                link.removeAttribute('aria-current');
              });
            }
          });
        }

        updateAccessibility(flkty.selectedIndex);

        flkty.on('change', function (index) {
          updateAccessibility(index);
        });

        flkty.on('settle', function () {
          updateAccessibility(flkty.selectedIndex);
        });
      });
});